<div class="p-grid">
    <!-- menu bar -->
    <div class="p-col-12">
        <p-menubar [model]="menuItems">
            <ng-template pTemplate="start" style="width: 100%;">
                <h2 style="display: inline;">Saved Search - </h2>
                <span style="width: fit-content;">
                    <p-toggleButton class="p-mb-2 p-ml-2" onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
                        [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActive" (onChange)="onStatusChanged()">
                    </p-toggleButton>
                </span>
                <!-- <span class="btnBars p-ml-2" *ngIf="selectedView=='split'" (click)="isLeftTableHide = !isLeftTableHide">
                    <i class="pi pi-minus-circle" *ngIf="!isLeftTableHide"></i>
                    <i class="pi pi-plus-circle" *ngIf="isLeftTableHide"></i>
                </span> -->
                <span class="p-input-icon-left" style="float: right; margin: 2px 5px 0px 5px;">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [formControl]="searchControl" placeholder="Search..." />
                </span>
            </ng-template>
            <ng-template pTemplate="end" style="width: 100%;">
            </ng-template>
        </p-menubar>
    </div>

    <!-- bodyArea -->
    <div class="p-col-12">
        <!-- list and split view -->
        <div class="p-grid">
            <div [ngClass]="{'p-md-12': selectedView=='list', 'p-md-3':selectedView=='split'}" *ngIf="!isLeftTableHide">
                <div class="card">
                    <p-contextMenu #cm [model]="configMenuItemsCM" [baseZIndex]="9999" (onShow)="buildContextMenu()"></p-contextMenu>
                    <p-table #savedSearchListTable appFloatThead [floatTableRef]="savedSearchListTable" floatTableClassRef="floatthead" [forceReflow]="showFloatHeader" [showFloatHeader]="showFloatHeader" [columns]="listCols" [value]="savedSearchesList" [paginator]="true" [style]="{width:'100%'}" [rows]="pageSize" [lazy]="true" [(first)]="first" [totalRecords]="totalRecords" (onLazyLoad)="getSavedSearchListByFilter($event)" selectionMode="single"
                        [(selection)]="selectedSearch" dataKey="id" (onRowSelect)="onRowSelect($event, 'Select')" (onRowUnselect)="onRowUnselect($event)" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [(contextMenuSelection)]="selectedSearch" [contextMenu]="cm" [rowsPerPageOptions]="tableShowMore"
                        styleClass="p-datatable-gridlines floatthead"
                        responsiveLayout="scroll" [resizableColumns]="true">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <ng-container *ngFor="let col of columns">
                                    <th *ngIf="col.show" [pSortableColumn]="col.field"
                                    style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                        {{col.header}}
                                        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order">
                                        </p-sortIcon>
                                        <!-- <span class="pi pi-filter p-ml-2 filtericon"
                                            [ngClass]="{'blink_me' : col.value.length > 0}"
                                            (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                                        </span> -->
                                    </th>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                                <ng-container *ngFor="let col of columns">
                                    <td *ngIf="col.show" style="text-align: left;">
                                        <ng-container [ngSwitch]="col?.dataType">
                                            <ng-container *ngSwitchCase="'date'">
                                                <div>
                                                    {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'string'">
                                                <div pTooltip="{{rowData[col.field]}}" tooltipPosition="top">
                                                    {{ (rowData[col.field]?.length>50)? (rowData[col.field] |
                                                    slice:0:50)+'...':(rowData[col.field]) }}
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <div>
                                                    {{ rowData[col.field] }}
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="listCols?.length||10">{{noSearchesFindOrLoadingText}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
                        <ng-template pTemplate>
                            <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                                (input)="savedSearchListTable.filter(curCol.value, curCol.field, 'contains')"
                                placeholder="Search by {{curCol.header}}" class="p-column-filter"
                                [value]="savedSearchListTable.filters[curCol.field] ? savedSearchListTable.filters[curCol.field].value : ''">
                        </ng-template>
                    </p-overlayPanel>
                </div>
            </div>
            <div class="p-col-12" *ngIf="selectedView == 'split' && selectedSearch"
                [ngClass]="{'p-md-12': isLeftTableHide, 'p-md-9': !isLeftTableHide}">
                <div class="card">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <p-menu #configmenu id="config_menu" [model]="configMenuItemsCM" [popup]="true" [baseZIndex]="9999"></p-menu>
                            <div class="tabviewIcons">
                                <div class="btnBars" pTooltip="Minimize" tooltipPosition="top" (click)="isLeftTableHide = !isLeftTableHide" *ngIf="isLeftTableHide">
                                    <i class="pi pi-minus-circle"></i>
                                </div>
                                <div class="btnBars" pTooltip="Maximize" tooltipPosition="top" (click)="isLeftTableHide = !isLeftTableHide" *ngIf="!isLeftTableHide">
                                    <i class="pi pi-plus-circle"></i>
                                </div>
                                <div pTooltip="Refresh" tooltipPosition="top" class="btnBars">
                                    <i class="pi pi-refresh" (click)="refreshSavedSearchQuery()"></i>
                                </div>
                                <div *ngIf="predictForecastPermission" pTooltip="Predict & Forecast" tooltipPosition="top" class="btnBars">
                                    <i class="pi pi-chart-line" (click)="openPredict()"></i>
                                </div>
                                <div *ngIf="savedSearchAnalyticsPermission" class="btnBars" pTooltip="Chat"
                                    tooltipPosition="top" (click)="showChatBox()" style="position: relative;">
                                    <i class="pi pi-comments"></i>
                                    <!-- <label style="position: absolute;right: 0;bottom: -4px;font-size: 10px;">Beta</label> -->
                                </div>
                                <div *ngIf="exportPermission" pTooltip="Export" tooltipPosition="top" class="btnBars">
                                    <i class="pi pi-upload" (click)="onExport()"></i>
                                </div>
                                <div class="btnBars" (click)="showColumnSetting()" pTooltip="Column Setting"
                                    tooltipPosition="top">
                                    <i class="pi pi-cog"></i>
                                </div>
                                <div class="btnBars" (click)="configmenu.toggle($event)">
                                    <i class="pi pi-bars"></i>
                                </div>
                                <div class="btnBars" (click)="onRowUnselect(selectedSearch)">
                                    <i class="pi pi-times"></i>
                                </div>
                            </div>
                            <p-tabView [(activeIndex)]="selectedTabIndex" (onChange)="detailTabChange($event)">
                                <!-- List -->
                                <p-tabPanel id="List" header="Result">
                                    <ng-template pTemplate="content">
                                        <app-saved-search-table-view
                                            [savedSearchId]="selectedSearch?.id"
                                            [isLeftTableHide]="isLeftTableHide"
                                            [savedSearchResponse]="savedSearchResponse"
                                            [selectedSearch]="selectedSearch"
                                            [loadFromResponse]="true"
                                            [refreshSavedSearch]="refreshSavedSearch"
                                            [openColumnSettings]="openColumnSettings"
                                            [exportSavedSearch]="exportSavedSearch">
                                        </app-saved-search-table-view>
                                    </ng-template>
                                </p-tabPanel>
                                <!-- overview -->
                                <p-tabPanel id="Overview" header="Query">
                                    <app-shared-detail-block [column]="listColsAll" [linkFields]="['name']" [data]="selectedSearch"
                                        [moduleName]="'SavedSearch'" (viewDetails)="onRowSelect(null, 'View')">
                                    </app-shared-detail-block>

                                    <div class="header">
                                        <h5>Rules</h5>
                                    </div>
                                    <p-table [value]="selectedSearch?.savedSearchRuleRequest" responsiveLayout="scroll">
                                        <ng-template pTemplate="header" let-rule>
                                            <tr>
                                                <th style="width: 100px;">Rule No.</th>
                                                <th>Choice</th>
                                                <th>Filter</th>
                                                <th>Operator</th>
                                                <th style="max-width: 300px;">Value</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rule let-index="rowIndex">
                                            <tr>
                                                <td style="width: 100px;">#{{index + 1}}</td>
                                                <td>{{rule.operator}}</td>
                                                <td>
                                                    <span *ngIf="rule.objectName !== null">{{rule.objectName}}</span>
                                                    <span
                                                        *ngIf="rule.templateName !== null">({{rule.templateName}})</span>
                                                    <span *ngIf="rule.objectName !== null">: </span> {{ rule?.parentLabelName ? rule?.parentLabelName + ': ' : '' }}{{rule.labelName}}
                                                </td>
                                                <td>{{rule.equation}}</td>
                                                <td style="max-width: 300px;">
                                                    <ng-container *ngIf="rule?.valuesJson">
                                                        <ng-container *ngIf="rule?.criteria?.toLowerCase() == 'radius'">
                                                            Address: {{rule?.valuesJson?.address}}, Radius:
                                                            {{rule?.valuesJson?.radius}} {{rule?.valuesJson?.radius > 2
                                                            ? 'miles':'mile'}}
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="rule?.criteria?.toLowerCase() == 'territoryname'">
                                                            Parent: {{rule?.valuesJson?.country}}, Name:
                                                            {{rule?.valuesJson?.name}}
                                                        </ng-container>
                                                        <!-- <ng-container *ngIf="rule?.criteria?.toLowerCase() != 'territoryname'">
                                                            <ng-container *ngFor="let val of rule?.valuesJson">
                                                                Parent: {{val?.country}}, Child: {{val?.name}}
                                                            </ng-container>
                                                        </ng-container> -->
                                                    </ng-container>
                                                    <ng-container *ngIf="!rule?.valuesJson">
                                                        <ng-container *ngFor="let val of rule.values; let i = index;">
                                                            <ng-container [ngSwitch]="rule?.dataType">
                                                                <ng-container *ngSwitchCase="'DateTime'">
                                                                    <ng-container [ngSwitch]="rule?.equation">
                                                                        <ng-container *ngSwitchCase="'Between'">
                                                                            {{ val?.split('AND')?.[0] |
                                                                            date:'MM/dd/yyyy'}} to {{
                                                                            val?.split('AND')?.[1] | date:'MM/dd/yyyy'}}
                                                                        </ng-container>
                                                                        <ng-container *ngSwitchCase="'Is'">
                                                                            <span *ngIf="val?.includes('-')">{{ val |
                                                                                date:'MM/dd/yyyy'}}</span>
                                                                        </ng-container>
                                                                        <ng-container *ngSwitchCase="'Is'">
                                                                            <span *ngIf="!val?.includes('-')">{{ val | ssDateTimeLabel }}</span>
                                                                        </ng-container>
                                                                        <ng-container *ngSwitchDefault>
                                                                            {{ val | date:'MM/dd/yyyy' }}
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </ng-container>
                                                                <ng-container *ngSwitchCase="'Time'">
                                                                    <span *ngIf="i==1" class="p-m-1">to</span>
                                                                    {{ val | onlyTime }}
                                                                </ng-container>
                                                                <ng-container *ngSwitchDefault>
                                                                    {{i>0?',':''}} <ng-container *ngIf="!rule?.compareWithField">{{ rule?.equation == 'Between' &&
                                                                    val?.split('AND')?.[0] && val?.split('AND')?.[1] ?
                                                                    val?.split('AND')?.[0] + ' to ' +
                                                                    val?.split('AND')?.[1] : val }}</ng-container><ng-container *ngIf="rule?.compareWithField"> {{ rule?.comparisonCriteriaParentLabel ? rule?.comparisonCriteriaParentLabel + ': ' : '' }}{{ rule?.comparisonCriteriaLabel }}</ng-container>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                        <ng-container *ngIf="rule?.equation == 'HasValue'">
                                                            <span>Any</span>
                                                        </ng-container>
                                                    </ng-container>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                    <div *ngIf="selectedSearch?.isCombinational" class="combine-rules-wrapper">
                                        <h6 class="combine-rules-header">
                                            Added Rules Combination
                                        </h6>
                                        <div class="p-grid p-mt-2">
                                            <div class="p-col-8">
                                                <strong class="p-ml-3">{{ selectedSearch?.ruleCombination | ssCombineRulesView:selectedSearch?.savedSearchRuleRequest }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </p-tabPanel>
                            </p-tabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add/Edit Saved Searches Start -->
<app-saved-search-add-edit *ngIf="displayAddEditDialog" [displayAddEditDialog]="displayAddEditDialog"
    [savedSearchViewOnly]="savedSearchViewOnly" [savedSearchCopy]="savedSearchCopy" [savedSearchEditId]="savedSearchEditId"
    [savedSearchDetails]="savedSearchDetails" (dialogClosed)="closeSavedSearchDialog()"
    (loadNewList)="loadSavedSearchList()" (savedSearchUpdated)="savedSearchUpdated($event)"></app-saved-search-add-edit>
<!-- Add/Edit Saved Searches End -->

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>

<!-- chat -->
<!-- <div *ngIf="selectedSearch && app.displayChatBox">
    <app-chatbot-modal [display]="displayChatBox" [chatBotInitializationData]="chatBotInitializationData"
    [moduleName]="'SavedSearch'" (onCancel)="onCancelChatBotDialog($event)"></app-chatbot-modal>
</div> -->

<!-- Add to Report -->
<p-dialog header="Add to Report" [(visible)]="displayAddReportDialog" [modal]="true" [responsive]="true"
    [closable]="true" [style]="{width: '45vw'}">
    <form [formGroup]="reportForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-lg-6">
                    <label>Report Section <span style="color: red;">*</span></label>
                    <liono-treeSelect class="border-bottom-input" [options]="reportMenus" appendTo="body" placeholder="Select section" formControlName="parentId"
                     [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                </div>
                <div class="p-col-12 p-lg-6">
                    <label>Report Name<span style="color: red;">*</span></label>
                    <input pInputText type="text" formControlName="name" id="nName" name="name" />
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayAddReportDialog=false;" label="Cancel"
            class="p-button-secondary"></button>
            <button type="button" pButton (click)="saveReportData(reportForm.value)" label="Save" [disabled]="!reportForm.valid"
            class="p-button-primary"></button>
    </p-footer>
</p-dialog>
<app-predict *ngIf="displayPredict" [selectedSearch]="selectedSearch" [display]="displayPredict"  (dialogClosed)="closePredict()"></app-predict>
<p-toast position="top-right"></p-toast>


<!-- add to list -->
 <app-add-to-list *ngIf="displayAddToList"
    [displayAddToList]="displayAddToList"
    [savedSearchId]="selectedSearch?.id"
    [savedSearchModuleId]="selectedSearch?.moduleId"
    [savedSearchTemplateId]="selectedSearch?.templateId"
    (listAdded)="backListView()"
    (dialogClosed)="cancelToList()">
</app-add-to-list>

<app-saved-search-added-list *ngIf="displayAddedList"
    [displayAddedList]="displayAddedList"
    [savedSearchId]="selectedSearch?.id"
    [savedSearchModuleId]="selectedSearch?.moduleId"
    [savedSearchTemplateId]="selectedSearch?.templateId"
    (tabRemoved)="backListView()"
    (dialogClosed)="cancelAddedList()">
</app-saved-search-added-list>
